import img1 from '../images/product-item/item-12.jpg'
import img2 from '../images/product-item/item-13.jpg'
import img3 from '../images/product-item/item-14.jpg'
import img4 from '../images/product-item/item-15.jpg'
import img5 from '../images/product-item/item-16.jpg'
import img6 from '../images/product-item/item-17.jpg'
import imga1 from '../images/avatar/avt-7.jpg'
import imga2 from '../images/avatar/avt-13.jpg'
import imga3 from '../images/avatar/avt-14.jpg'
import imga4 from '../images/avatar/avt-15.jpg'
import imga5 from '../images/avatar/avt-16.jpg'
import imga6 from '../images/avatar/avt-17.jpg'

const dataTrendingCollections = [
    {
        img: img1,
        title: '‘’3D Space Rocket With Smoke’’',
        tags: 'PANDA',
        imgAuthor: imga1,
        name:'Daniel M.Bivens',
        price: '5.23 ETH',
        priceChange: '$32.420'
    },
    {
        img: img2,
        title: '‘’3D Space Rocket With Smoke’’',
        tags: 'PANDA',
        imgAuthor: imga2,
        name:'Daniel M.Bivens',
        price: '5.23 ETH',
        priceChange: '$32.420'
    },
    {
        img: img3,
        title: '‘’3D Space Rocket With Smoke’’',
        tags: 'PANDA',
        imgAuthor: imga3,
        name:'Daniel M.Bivens',
        price: '5.23 ETH',
        priceChange: '$32.420'
    },
    {
        img: img4,
        title: '‘’3D Space Rocket With Smoke’’',
        tags: 'PANDA',
        imgAuthor: imga4,
        name:'Daniel M.Bivens',
        price: '5.23 ETH',
        priceChange: '$32.420'
    },
    {
        img: img5,
        title: '‘’3D Space Rocket With Smoke’’',
        tags: 'PANDA',
        imgAuthor: imga5,
        name:'Daniel M.Bivens',
        price: '5.23 ETH',
        priceChange: '$32.420'
    },
    {
        img: img6,
        title: '‘’3D Space Rocket With Smoke’’',
        tags: 'PANDA',
        imgAuthor: imga6,
        name:'Daniel M.Bivens',
        price: '5.23 ETH',
        priceChange: '$32.420'
    },


]

export default dataTrendingCollections;